(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('money-transfer-log', {
                parent: 'entity',
                url: '/money-transfer-log?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.moneyTransferLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-logs.html',
                        controller: 'MoneyTransferLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('moneyTransferLog');
                        $translatePartialLoader.addPart('transferType');
                        $translatePartialLoader.addPart('moneyTransferLogStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('money-transfer-log-detail', {
                parent: 'entity',
                url: '/money-transfer-log/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.moneyTransferLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-detail.html',
                        controller: 'MoneyTransferLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('moneyTransferLog');
                        $translatePartialLoader.addPart('transferType');
                        $translatePartialLoader.addPart('moneyTransferLogStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MoneyTransferLog', function ($stateParams, MoneyTransferLog) {
                        return MoneyTransferLog.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('money-transfer-log.new', {
                parent: 'money-transfer-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-dialog.html',
                        controller: 'MoneyTransferLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    transferType: null,
                                    createDate: null,
                                    transactionCode: null,
                                    payeeName: null,
                                    payeeAccountNo: null,
                                    payerAcountNo: null,
                                    payerName: null,
                                    transferDate: null,
                                    status: null,
                                    refrenceCode: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('money-transfer-log', null, {reload: true});
                    }, function () {
                        $state.go('money-transfer-log');
                    });
                }]
            })
            .state('money-transfer-log.edit', {
                parent: 'money-transfer-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-dialog.html',
                        controller: 'MoneyTransferLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['MoneyTransferLog', function (MoneyTransferLog) {
                                return MoneyTransferLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('money-transfer-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('money-transfer-log.delete', {
                parent: 'money-transfer-log',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/money-transfer-log/money-transfer-log-delete-dialog.html',
                        controller: 'MoneyTransferLogDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MoneyTransferLog', function (MoneyTransferLog) {
                                return MoneyTransferLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('money-transfer-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
